/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React, { useState } from 'react';
import clsx from "clsx";
import AppSpinner from "../loader/AppSpinner";

interface LoadingButtonProps {
    isLoading?: boolean;
    onClick?: () => void | Promise<void>;
    text?: string;
    loadingText?: string;
    type? : "submit" | "reset" | "button",
    extraClass? : string;
    loadClass? : string;
    id? : string;
    reverseTextAndIcon? : boolean;
    icon? : any;
}

const AppSubmit = (props: LoadingButtonProps) => {
    const { isLoading, onClick, text, type, id, loadingText, extraClass, reverseTextAndIcon, icon, loadClass } = props;
    const classes = clsx("flex items-center justify-center gap-2 linear mt-14 w-48 bg-black py-[16px] text-xl font-medium text-white border-2 border border-black hover:scale-105 transition-transform ease-in-out duration-300 ", extraClass || '', loadClass || '');

    const [isInternalLoading, setIsInternalLoading] = useState(false);

    const handleClick = async () => {
        setIsInternalLoading(true);
        try {
            onClick && await onClick();
        } finally {
            setIsInternalLoading(false);
        }
    };

    if (isLoading || isInternalLoading) {
        return (
            <button
                id={id}
                disabled
                className={classes}>
                <AppSpinner/>
                {loadingText}
            </button>
        )
    }

    return (
        <button
            id={id}
            type={type || "button"}
            onClick={handleClick}
            className={classes}>
            {!reverseTextAndIcon ? (<>{icon} {text}</>) : (<>{text} {icon}</>)}
        </button>
    )
};

export default AppSubmit;